(function(){
  'use strict';
  var cfg=window.LMP_APP_CONFIG||{};
  var navigating=false;

  function cleanPath(path){
    path=String(path||'/').replace(/\/+$/,'');
    return path||'/';
  }
  function isNativePath(path){
    path=cleanPath(path);
    return path==='/'||path==='/cart'||path==='/search'||path==='/account'||path==='/pages/categories-parapharmacie'||path==='/pages/marques'||path.indexOf('/collections/')===0||path.indexOf('/products/')===0;
  }
  function currentPreviewParams(url){
    var here=new URLSearchParams(location.search);
    if(!cfg.previewMode)return url;
    if(here.get('preview_theme_id')&&!url.searchParams.get('preview_theme_id'))url.searchParams.set('preview_theme_id',here.get('preview_theme_id'));
    if(!url.searchParams.get('lmp_app_preview'))url.searchParams.set('lmp_app_preview','1');
    return url;
  }
  function toUrl(raw){
    try{return currentPreviewParams(new URL(raw||'/',location.origin))}catch(e){return null}
  }
  function clearNativeRoot(){
    var old=document.getElementById('lmp-native-app');
    if(old)old.remove();
    try{if(typeof root!=='undefined')root=null}catch(e){}
    document.documentElement.classList.add('lmp-native-route');
  }
  function normalizeCartMarkup(){
    document.querySelectorAll('#lmp-native-app .lmp-cart-item').forEach(function(row){
      if(row.querySelector('.lmp-cart-item__bottom'))return;
      var copy=row.querySelector('.lmp-cart-item__copy');
      if(!copy)return;
      var qty=copy.querySelector('.lmp-cart-item__qty');
      var price=row.querySelector('.lmp-cart-item__price');
      var remove=row.querySelector('.lmp-cart-remove');
      if(!qty&&!price)return;
      copy.classList.add('lmp-cart-item__body');
      var bottom=document.createElement('div');
      bottom.className='lmp-cart-item__bottom';
      if(qty)bottom.appendChild(qty);
      if(price)bottom.appendChild(price);
      copy.appendChild(bottom);
      if(remove)copy.appendChild(remove);
      Array.prototype.slice.call(row.children).forEach(function(child){
        if(child!==copy&&!child.classList.contains('lmp-cart-item__img')&&child.childElementCount===0&&!child.textContent.trim())child.remove();
      });
    });
  }

  if(typeof window.buildCart==='function'||typeof buildCart==='function'){
    try{
      var baseBuildCart=(typeof buildCart==='function')?buildCart:window.buildCart;
      var wrapped=function(cart){
        var out=baseBuildCart(cart);
        normalizeCartMarkup();
        requestAnimationFrame(normalizeCartMarkup);
        return out;
      };
      window.buildCart=wrapped;
      try{buildCart=wrapped}catch(e){}
    }catch(e){}
  }

  function renderCurrent(){
    var path=cleanPath(location.pathname);
    if(!isNativePath(path))return false;
    clearNativeRoot();
    window.scrollTo(0,0);
    try{
      if(path==='/')renderHome();
      else if(path==='/cart')renderCart();
      else if(path==='/search')renderSearch();
      else if(path==='/account')renderAccount();
      else if(path==='/pages/categories-parapharmacie')renderCategories();
      else if(path==='/pages/marques')renderBrands();
      else if(path.indexOf('/collections/')===0)renderCollection();
      else if(path.indexOf('/products/')===0)renderProduct();
      else return false;
    }catch(e){
      return false;
    }
    requestAnimationFrame(function(){
      normalizeCartMarkup();
      document.documentElement.classList.remove('lmp-route-changing');
    });
    return true;
  }

  function navigate(raw,replace){
    if(navigating)return;
    var u=toUrl(raw);
    if(!u||u.origin!==location.origin||!isNativePath(u.pathname)){
      location.href=u?u.href:raw;
      return;
    }
    if(u.pathname===location.pathname&&u.search===location.search&&u.hash===location.hash)return;
    navigating=true;
    document.documentElement.classList.add('lmp-native-route','lmp-route-changing');
    try{
      if(replace)history.replaceState({lmpApp:true},'',u.pathname+u.search+u.hash);
      else history.pushState({lmpApp:true},'',u.pathname+u.search+u.hash);
    }catch(e){
      navigating=false;
      throw e;
    }
    // Yield an initial paint before expensive route rendering (mobile INP).
    requestAnimationFrame(function(){
      setTimeout(function(){
        try{
          if(!renderCurrent())location.href=u.href;
        }finally{
          navigating=false;
        }
      },0);
    });
  }
  window.LMP_NAVIGATE=navigate;

  try{
    if(typeof go==='function'){
      go=function(path,extra){
        var target;
        try{target=(typeof appUrl==='function')?appUrl(path,extra):path}catch(e){target=path}
        navigate(target,false);
      };
      window.go=go;
    }
  }catch(e){}

  document.addEventListener('click',function(e){
    if(e.defaultPrevented||e.button>0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;
    var t=e.target;
    if(!t||!t.closest)return;
    var a=t.closest('#lmp-native-app a[data-lmp-link],#lmp-native-app a[data-lmp-mega-link]');
    if(!a||a.target==='_blank'||a.hasAttribute('download'))return;
    var u=toUrl(a.href);
    if(!u||u.origin!==location.origin||!isNativePath(u.pathname))return;
    e.preventDefault();
    navigate(u.href,false);
  },false);

  window.addEventListener('popstate',function(){
    if(!((cfg.standalone||cfg.previewMode)&&isNativePath(location.pathname)))return;
    document.documentElement.classList.add('lmp-native-route','lmp-route-changing');
    requestAnimationFrame(function(){setTimeout(renderCurrent,0)});
  });

  document.addEventListener('DOMContentLoaded',function(){
    normalizeCartMarkup();
    document.documentElement.classList.remove('lmp-route-changing');
  });
})();
